import { render } from "./AddCreditDialog.vue?vue&type=template&id=5ec0b863&scoped=true"
import script from "./AddCreditDialog.vue?vue&type=script&lang=js"
export * from "./AddCreditDialog.vue?vue&type=script&lang=js"

import "./AddCreditDialog.vue?vue&type=style&index=0&id=5ec0b863&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec0b863"]])

export default __exports__